module.exports = __webpack_public_path__ + "img/d404a4f.png";